import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Renders children only when user is admin; otherwise redirects to dashboard. */
export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const { profile } = useAuth();
  if (profile?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
